"use client";

import { Box, CircularProgress, Container, styled, Typography } from "@mui/material";
import { ReactNode } from "react";

const LoadingWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: "24px"
});

const LoadingSquare = styled(Box)({
  borderRadius: "3px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  maxWidth: "400px",
  aspectRatio: "1/1",
  background:
    "linear-gradient(178deg, rgba(66, 223, 244, 0.50) 9.84%, rgba(151, 71, 255, 0.50) 99.92%), rgba(255, 255, 255, 0.40)"
});

const LoadingInfo = styled(Box)({
  textAlign: "center"
});

const LoadingContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "24px"
});

interface LoadingBoxProps {
  children?: ReactNode;
  showSquare?: boolean;
  progress?: number;
}

// Helper component for CircularProgressWithLabel pattern
function CircularProgressWithLabel(props: { value: number }) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" value={props.value} size={32} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

export default function LoadingBox({ children, showSquare = true, progress }: LoadingBoxProps) {
  const showDeterminateProgress = progress !== undefined && progress > 0;

  return (
    <Container maxWidth="lg">
      <LoadingWrapper>
        {showSquare ? (
          <LoadingSquare>
            {showDeterminateProgress ? (
              <CircularProgressWithLabel value={progress} />
            ) : (
              <CircularProgress variant="indeterminate" size={32} />
            )}
          </LoadingSquare>
        ) : (
          <LoadingContent>
           {showDeterminateProgress ? (
              <CircularProgressWithLabel value={progress} />
            ) : (
              <CircularProgress variant="indeterminate" size={32} />
            )}
          </LoadingContent>
        )}
        <LoadingInfo>{children}</LoadingInfo>
      </LoadingWrapper>
    </Container>
  );
}
